/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@mui/styles';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Edit from '@mui/icons-material/Edit';
import Delete from '@mui/icons-material/Delete';
import SimpleTooltip from './SimpleTooltip';
import usePlatformRegion from '../utils/hooks/usePlatformRegion';
import { getNoKnownLossLetterText } from '../console/workflows/bind-quote/utils/bind.utils';

export const Expand = (
  props: any,
  isShowingDetails: any,
  classList: any,
  toggleDetails: any
) => {
  return (
    <ExpandMore
      className={isShowingDetails ? classList.toggle : classList.icon}
      onClick={toggleDetails(props.id)}
    />
  );
};

export const EditIcon = (classList: any, enterEdit: any) => {
  return <Edit className={classList.iconStyle} onClick={enterEdit} />;
};

export const DeleteIcon = (classList: any, enterDelete: any) => {
  return <Delete className={classList.iconStyle} onClick={enterDelete} />;
};

export const NoKnownLossLetterIndicator = ({ status }: any) => {
  const classes = useLossLetterStyles();

  // Platform detection and text configuration
  const region = usePlatformRegion();
  const textConfig = getNoKnownLossLetterText(region);

  if (status === 'PROVIDED') {
    return (
      <SimpleTooltip title={textConfig.providedTooltip}>
        <img
          src="images/GreenFlag.svg"
          // @ts-expect-error TS(2339): Property 'flag' does not exist on type 'ClassNameM... Remove this comment to see the full error message
          className={classes.flag}
          alt="loss letter received indicator"
        />
      </SimpleTooltip>
    );
  }

  if (status === 'REQUIRED') {
    return (
      <SimpleTooltip title={textConfig.requiredTooltip}>
        {/* @ts-expect-error TS(2339): Property 'flag' does not exist on type 'ClassNameM... Remove this comment to see the full error message */}
        <img src="images/RedFlag.svg" className={classes.flag} alt="" />
      </SimpleTooltip>
    );
  }

  return null;
};

// @ts-expect-error TS(2345): Argument of type '({ config }: DefaultTheme) => { ... Remove this comment to see the full error message
const useLossLetterStyles = makeStyles(({ config }) => ({
  fontSize: config.textSizes.primer,
  marginLeft: '0.4166666667rem',
  width: '1.2rem',
  height: '.8rem',
}));
